import { useState } from "react";
import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import Theme from '../../styles/Theme/Theme';
import { Text } from "../Global/Atomics/Text";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import CustomIcon from "../Global/Icons/CustomIcon";

export const SatisfactionWidget = ({ canvas = false }) => {
    const { data, isLoading } = useFetch(query.path.satisfaction, 'getSatisfaction', null, 300000);
    const [isActive, setIsActive] = useState(0);
    if (!isLoading && isActive !== data?.value) {
        setIsActive(data?.value);
    }

    const emojies = [
        {
            icon: 'AwfulSmile',
            text: 'Awful',
            color: Theme.color['critical-base']
        },
        {
            icon: 'BadSmile',
            text: 'Bad',
            color: Theme.color['high-base']
        },
        {
            icon: 'OkSmile',
            text: 'Ok',
            color: Theme.color['medium-base']
        },
        {
            icon: 'GoodSmile',
            text: 'Good',
            color: Theme.color['low-base']
        },
        {
            icon: 'GreatSmile',
            text: 'Great',
            color: Theme.color['low-base']
        }
    ];

    return (
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} justifyContent='space-between' style={{ overflow: 'hidden' }}>
            <div style={{ display: "flex", alignItems: 'center', marginBottom: Theme.spacing.videowall.xxs, flexShrink: 0 }}>
                <CustomIcon icon={'Check'} iconSize='sm' color={Theme.color['teal-4']} />
                <Text color={Theme.color['coolgray-12']} marginLeft={Theme.spacing.videowall.xxs} fontSize='text_sm' fontWeight={Theme.typography.weight.medium} style={{ whiteSpace: 'nowrap' }}>Satisfaction</Text>
            </div>
            <div style={{ display: "flex", justifyContent: 'space-around', alignItems: 'flex-end', flex: 1, minHeight: 0 }}>
                {emojies.map((val, key) => {
                    const activeSize = canvas ? 'lg' : 'xl';
                    const inactiveSize = canvas ? 'sm' : 'md';
                    return (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} key={key}>
                        <CustomIcon color={isActive === key ? val.color : Theme.color['coolgray-6']} icon={val.icon} iconSize={isActive === key ? activeSize : inactiveSize} marginBottom={Theme.spacing.videowall.xs} />
                        <Text color={isActive === key ? Theme.color['coolgray-12'] : Theme.color['coolgray-6']} marginTop={Theme.spacing.videowall.xs} fontSize={canvas ? 'text_sm' : 'text_md'} fontWeight={Theme.typography.weight.regular} style={{ whiteSpace: 'nowrap' }}>{val.text}</Text>
                    </div>)
                })}
            </div>
        </WidgetCard>
    )
};